import projectData from '../data/projectData'
const RelatedProjects = ({ category }) => {
  const projects = projectData[category] || [];

  if (!projects.length) return null;

  return (
    <section className="related-projects">
      <h2 className="related-title">Related Projects</h2>

      <div className="tech-projects-grid">
        {projects.slice(0, 6).map((project, index) => (
          <div
            key={index}
            className={`project-card ${project.url ? "clickable" : ""}`}
          >
            {project.url ? (
              <a
                href={project.url}
                target="_blank"
                rel="noopener noreferrer"
                className="project-link"
              >
                <div className="project-image-wrapper">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="project-image"
                  />
                </div>
                <div className="project-info">
                  <h3 className="project-title">{project.title}</h3>
                </div>
              </a>
            ) : (
              <>
                <div className="project-image-wrapper">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="project-image"
                  />
                </div>
                <div className="project-info">
                  <h3 className="project-title">{project.title}</h3>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default RelatedProjects;
